export interface CreateTrackingLink {
  companyId: string;
  driverId: string;
  truckId: string;
  expiresIn: string;
}

export interface TrackingLink {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  companyId: string;
  truckId: string;
  driverId: string;
  expiresIn: string;

  deletionLoading?: boolean;
  actionLoading?: boolean;
}
